import React from 'react';
import {
  AccordionDetails,
  AccordionSummary,
  ClickAwayListener,
} from '@mui/material';
import Table from '@mui/material/Table';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import {
  StyledTableCell,
  StyledTableRow,
} from '../../Timesheets/CustomStyles/StyledTable';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Card, Typography, Box, Grid, Tooltip, Accordion } from '@mui/material';
import './TasksCard.css';
import DateRangeIcon from '@mui/icons-material/DateRange';
import { Container } from '@mui/system';
import BeenhereOutlinedIcon from '@mui/icons-material/BeenhereOutlined';
import HomeIcon from '@mui/icons-material/Home';
import CorporateFareIcon from '@mui/icons-material/CorporateFare';
import {
  getHHMMSSFromSeconds,
  msToTime,
} from '../../../utils/TimeConversionFunctions';
import UserActions from '../../../components/Table/Table-User-Actions/UserActions';
import NaturePeopleIcon from '@mui/icons-material/NaturePeople';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import moment from 'moment';
import {
  APPRIASAL_STATUS,
  DATE,
  EXTERNAL,
  PROJECT,
  TaskType,
  WFO,
} from '../TaskConstants';
const TaskCards = (props) => {
  const [expanded, setExpanded] = React.useState(false);
  const flipSummaryContainer = () => () => {
    setExpanded(!expanded);
  };
  const calculateTotalDuration = () => {
    let totalTime = 0;
    item.timings.map((row) => {
      totalTime = totalTime + row.officeHours;
    });
    return msToTime(totalTime);
  };
  const { item, rowId, getTaskForEdit } = props;
  const handleClickAway = () => {
    setExpanded(false);
  };

  const currentMonth = new Date().getMonth();
  const currentYear = new Date().getFullYear();

  const taskMonth = new Date(item.startDate).getMonth();
  const taskYear = new Date(item.startDate).getFullYear();

  // Weekend working tasks are managed from the Weekend Working Hours tab.
  const isEditable =
    item.taskType !== 'WEEKEND_WORKING' &&
    ((taskMonth === currentMonth && taskYear === currentYear) ||
      (item.taskType !== 'EXTERNAL' && item.taskType !== 'WORK_TRAVEL'));

  return (
    <Container
      maxWidth={false}
      sx={{
        margin: 0,
        padding: '16px',
        textAlign: 'left',
        width: '100%',
      }}
    >
      <ClickAwayListener onClickAway={handleClickAway}>
        <Box
          sx={{
            overflow: 'hidden',
          }}
        >
          <Card sx={{ mb: 2 }}>
            <Grid container>
              <Grid item md={0.4} xs={4} sm={4} sx={{ mt: '0.4rem' }}>
                {item.isAppraisal === true ? (
                  <Tooltip
                    title={
                      <Typography sx={{ fontSize: '0.8rem' }}>
                        {APPRIASAL_STATUS}
                      </Typography>
                    }
                    placement="bottom"
                  >
                    <BeenhereOutlinedIcon
                      fontSize="small"
                      sx={{ color: '#FFA500', ml: 1 }}
                    />
                  </Tooltip>
                ) : (
                  <BeenhereOutlinedIcon
                    fontSize="small"
                    sx={{ color: 'rgba(0, 0, 0, 0.25)', ml: 1, height: '18px' }}
                  />
                )}
              </Grid>
              <Grid
                item
                md={1.8}
                xs={12}
                sm={12}
                textAlign="center"
                sx={{ mt: '0.9rem', mb: 'auto' }}
              >
                <Tooltip
                  title={
                    <Typography sx={{ fontSize: '0.8rem' }}>
                      {PROJECT}
                    </Typography>
                  }
                  placement="left"
                >
                  <Typography
                    sx={{
                      fontFamily: '"Roboto","Helvetica","Arial","sans-serif"',
                      fontWeight: 1,
                      fontSize: '1.1rem',
                      lineHeight: 1.5,
                      borderLeft: 'solid',
                      borderColor: '#2196F3',
                      backgroundColor: '#ddffff',
                      textTransform: 'capitalize',
                    }}
                  >
                    {item.projectName}
                  </Typography>
                </Tooltip>
              </Grid>
              <Grid item md={5.8} xs={6} sm={6} sx={{ minWidth: 0 }}>
                <Grid display="flex" p={1}>
                  <Grid>
                    <Tooltip
                      title={
                        <Typography sx={{ fontSize: '0.8rem' }}>
                          {TaskType(item.taskType)}
                        </Typography>
                      }
                      placement="right"
                    >
                      {item.taskType === 'WFH' ? (
                        <HomeIcon fontSize="small" color="primary" />
                      ) : item.taskType === 'OFFICEHRS' ? (
                        <CorporateFareIcon color="primary" />
                      ) : (
                        <NaturePeopleIcon color="primary" />
                      )}
                    </Tooltip>
                  </Grid>
                  <Grid
                    pt={1}
                    sx={{
                      mr: 'auto',
                      ml: 'auto',
                      maxWidth: '100%',
                      minWidth: 0,
                      overflow: 'hidden',
                    }}
                  >
                    <Tooltip
                      title={
                        <Typography sx={{ fontSize: '0.8rem' }}>
                          {item.title}
                        </Typography>
                      }
                      arrow
                    >
                      <Typography
                        noWrap
                        sx={{
                          fontFamily:
                            '"Roboto","Helvetica","Arial","sans-serif"',
                          fontWeight: 1,
                          fontSize: '1rem',
                          lineHeight: 1.5,
                          textTransform: 'capitalize',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                        }}
                      >
                        {item.title}
                      </Typography>
                    </Tooltip>
                  </Grid>
                </Grid>
                <Box pb={1} ml={4} sx={{ maxWidth: '100%', overflow: 'hidden' }}>
                  <Tooltip
                    title={<Typography>{item.description}</Typography>}
                    arrow
                  >
                    <Typography
                      noWrap
                      sx={{
                        fontFamily: '"Roboto","Helvetica","Arial","sans-serif"',
                        fontWeight: 1,
                        fontSize: '0.8rem',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                      }}
                    >
                      {item.description}
                    </Typography>
                  </Tooltip>
                </Box>
              </Grid>
              <Grid item md={3} sx={{ mt: 'auto', mb: 'auto' }}>
                <Box textAlign="left" mb={1.5} ml={6}>
                  <Tooltip
                    title={
                      <Typography sx={{ fontSize: '0.8rem' }}>
                        {DATE}
                      </Typography>
                    }
                    placement="top"
                  >
                    {item.taskType === 'OFFICEHRS' &&
                    item.timings.length > 1 &&
                    item.startDate != item.endDate ? (
                      <Typography sx={{ fontSize: '0.75rem' }}>
                        <DateRangeIcon
                          color="primary"
                          fontSize="small"
                          title={DATE}
                          sx={{ mr: 1 }}
                        />
                        {moment(item.startDate).format('DD-MMM-YYYY')} to{' '}
                        {moment(item.endDate).format('DD-MMM-YYYY')}
                      </Typography>
                    ) : (
                      <Typography sx={{ fontSize: '0.8rem' }}>
                        <DateRangeIcon
                          color="primary"
                          fontSize="small"
                          title={DATE}
                          sx={{ mr: 1 }}
                        />
                        {moment(item.startDate).format('DD-MMM-YYYY')}
                      </Typography>
                    )}
                  </Tooltip>
                </Box>
                <Box textAlign="left" ml={6}>
                  <Tooltip
                    title={
                      <Typography sx={{ fontSize: '0.8rem' }}>
                        {TaskType(item.taskType)}
                      </Typography>
                    }
                    placement="bottom"
                  >
                    {item.taskType === 'WFH' ? (
                      <Typography sx={{ fontSize: '0.82rem' }}>
                        <AccessTimeFilledIcon
                          color="primary"
                          fontSize="small"
                          sx={{ mr: 1 }}
                        />
                        {msToTime(item.timings[0].wfhHours)}
                      </Typography>
                    ) : item.taskType === 'OFFICEHRS' ? (
                      <Typography sx={{ fontSize: '0.8rem' }}>
                        <AccessTimeFilledIcon
                          color="primary"
                          fontSize="small"
                          sx={{ mr: 1 }}
                        />
                        {calculateTotalDuration()}
                      </Typography>
                    ) : (
                      <Typography sx={{ fontSize: '0.8rem' }}>
                        <AccessTimeFilledIcon
                          color="primary"
                          fontSize="small"
                          sx={{ mr: 1 }}
                        />
                        {msToTime(
                          item.timings[0]?.externalHours ||
                            item.timings[0]?.clientOfficeHours ||
                            item.timings[0]?.workTravelHours ||
                            item.timings[0]?.weekendWorkingHours ||
                            0,
                        )}
                      </Typography>
                    )}
                  </Tooltip>
                </Box>
              </Grid>
              {isEditable && (
                <Grid item md={1} sx={{ mt: 'auto', mb: 'auto' }}>
                  <Box sx={{ p: 1 }}>
                    <UserActions
                      rowId={rowId}
                      getTaskForEdit={getTaskForEdit}
                    />
                  </Box>
                </Grid>
              )}
            </Grid>
            {item.taskType === 'OFFICEHRS' && item.timings.length > 1 ? (
              <Box>
                <Accordion
                  expanded={expanded}
                  onChange={() => setExpanded(!expanded)}
                  disableGutters
                  elevation={0}
                  sx={{ width: '100%' }}
                >
                  <Grid
                    className="leave-container pb-0 pt-0"
                    sx={{
                      display: 'flex',
                      justifyContent: 'center',
                      marginLeft: '-12%',
                    }}
                  >
                    <AccordionSummary expandIcon={<KeyboardArrowDownIcon />} />
                  </Grid>
                  <Grid
                    className="leave-container pb-0 pt-0"
                    sx={{ width: '100%' }}
                  >
                    <AccordionDetails>
                      <Table size="small">
                        <TableHead>
                          <TableRow>
                            <StyledTableCell
                              style={{ backgroundColor: '#4d6cd9' }}
                            >
                              Date
                            </StyledTableCell>
                            <StyledTableCell
                              style={{ backgroundColor: '#4d6cd9' }}
                            >
                              Title
                            </StyledTableCell>
                            <StyledTableCell
                              style={{ backgroundColor: '#4d6cd9' }}
                            >
                              Duration
                            </StyledTableCell>
                            <StyledTableCell
                              style={{ backgroundColor: '#4d6cd9' }}
                            >
                              Description
                            </StyledTableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {item.timings.map((row) => (
                            <StyledTableRow key={row.DATE}>
                              <StyledTableCell component="th" scope="row">
                                {row.date}
                              </StyledTableCell>
                              <StyledTableCell>
                                <Tooltip title={row.title || ''} arrow>
                                  <Typography
                                    sx={{
                                      maxWidth: '12rem',
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                      whiteSpace: 'nowrap',
                                    }}
                                  >
                                    {row.title}
                                  </Typography>
                                </Tooltip>
                              </StyledTableCell>
                              <StyledTableCell>
                                {getHHMMSSFromSeconds(row.officeHours / 1000)}
                              </StyledTableCell>
                              <StyledTableCell size="small">
                                <Tooltip title={row.description || ''} arrow>
                                  <Typography
                                    sx={{
                                      maxWidth: '14rem',
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                      whiteSpace: 'nowrap',
                                    }}
                                  >
                                    {row.description}
                                  </Typography>
                                </Tooltip>
                              </StyledTableCell>
                            </StyledTableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </AccordionDetails>
                  </Grid>
                </Accordion>
              </Box>
            ) : (
              ''
            )}
          </Card>
        </Box>
      </ClickAwayListener>
    </Container>
  );
};

export default TaskCards;
